import Web3 from 'web3';
import usdtAbi from './usdtAbi.json'
import { contractAddress } from './contractAddress';



export const approveToken = async (
    amount,
    address, toast,
    connector
) => {
    try {
        
        const provider = await connector?.getProvider?.();

        if (!provider) {
            toast.error('Web3 provider not found');
            return;
        }

        const web3 = new Web3(provider);
        const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
        const usdtAllowance = await usdtContract.methods.allowance(address, contractAddress?.pillMLM).call();

        const valueInWei = web3.utils.toWei(amount, 'ether');

        if (usdtAllowance < valueInWei) {

            const usdtApprove = await usdtContract.methods.approve(contractAddress?.pillMLM, valueInWei).send({ from: address });
            if (usdtApprove?.transactionHash) {
                return true;
            } else {
                return !!usdtApprove?.transactionHash;
            }
        }

        return true
    } catch (error) {
       
        const errorMessage = error?.reason || error?.message || "Transaction rejected";
          toast.error(`Transaction Failed: ${errorMessage}`);
          return false
  


    }
};


export const usdtTokenBalance = async (address, connector) => {
    try {
        const provider = await connector?.getProvider?.();

        if (!provider) {
           
            return;
        }

        const web3 = new Web3(provider);
        const usdtContract = new web3.eth.Contract(usdtAbi, contractAddress?.USDT);
        const usdtUserBalance = await usdtContract.methods.balanceOf(address).call();
        const usdtUserBalanceInUnits = web3.utils.fromWei(usdtUserBalance, 'ether');
        return usdtUserBalanceInUnits
    } catch (error) {
return "0";
    }
}